import axios from "axios";
import * as Sentry from "@sentry/browser";

/**
 * Report an API error to Sentry, tagged with the request that caused it
 * @param {Object} error - The error object from axios
 * @param {number} status - The HTTP status code, if any
 */
const reportApiError = (error, status) => {
  if (import.meta.env.VITE_ENV === "test" || axios.isCancel(error)) return;

  Sentry.withScope((scope) => {
    scope.setTag("apiMethod", error.config?.method?.toUpperCase());
    scope.setTag("apiStatus", String(status || "network_error"));
    scope.setExtra("url", error.config?.url);
    scope.setExtras(error.info);
    Sentry.captureException(error);
  });
  error.__sentryReported = true;
};

export default reportApiError;
